import { useAuth } from '@clerk/clerk-react'
import { trpc } from './trpc'

// Gleap identity-verification hash (server-side HMAC of the Clerk user id).
export const useGetGleapUserHash = () => {
	const { isSignedIn } = useAuth()

	return trpc.gleap.getUserHash.useQuery(undefined, {
		enabled: !!isSignedIn,
		staleTime: 60 * 60_000,
		retry: false,
	})
}

// Readers of the CRM support tools (`support.billing`, `support.stores`) for the
// Gleap agent-tool handlers, which run outside React: plain promises, no cache.
export const useSupportToolReaders = () => {
	const utils = trpc.useUtils()

	return {
		readBilling: (input: { from?: string; to?: string }) => utils.client.support.billing.query(input),
		readStores: (input: { q?: string }) => utils.client.support.stores.query(input),
	}
}
